export const TITLE = 'Address';
export const DESCRIPTION = 'Street Number, Postcode, Town';
export const DB_PREFIX = 'mainAddress';
